module.exports = __webpack_public_path__ + "img/diagnosis-dialog-loading-front-icon.feacd546.png";